import React, { useState } from "react";
import { FaMapMarkerAlt, FaStar, FaArrowRight, FaChevronDown, FaMountain, FaHotel, FaUmbrellaBeach, FaGem } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../css/styles.css";

/* ─── LODGE DATA ─── */
const tanzaniaLodges = [
  {
    region: "Manyara",
    lodges: [
      { name: "Escarpment Luxury Lodge", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775810965/Escarpment_Luxury_lodge_2_tgogk9.jpg", desc: "A globally recognized safari lodge offering luxurious accommodations and exceptional service, set against the dramatic backdrop of Lake Manyara. Perfect for couples, families, and adventure travelers seeking the ideal blend of comfort, style, and Tanzanian wilderness." },
      { name: "Manyara's Secret", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775810951/Manyara_Secret_yxkesi.webp", desc: "A boutique luxury lodge perched above Lake Manyara, offering breathtaking views and close encounters with elephants, monkeys, and tree-climbing lions. Enjoy private terraces, plunge pools, spa treatments, and personalized safari experiences just minutes from Lake Manyara, Tarangire, and Ngorongoro Crater." },
    ],
  },
  {
    region: "Tarangire",
    lodges: [
      { name: "Tarangire Treetops", desc: "One of the most iconic lodges in Tarangire, famous for its luxury treehouse suites built around ancient baobab trees. Elevated rooms, sweeping savannah views, and frequent elephant sightings make it a very memorable safari stay." },
      { name: "Oliver's Camp", desc: "A classic authentic safari camp known for its exceptional guiding and intimate wilderness experience. Located in a remote part of Tarangire, it offers walking safaris, off-road game drives, and a more immersive bush experience." },
    ],
  },
  {
    region: "Serengeti",
    lodges: [
      { name: "Elewana Serengeti Pioneer Camp", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775810950/Elewana_Serengeti_Pioneer_g5tdwb.webp", desc: "Set in the South-Central Serengeti within the Moru Kopjes, this boutique tented camp offers sweeping views over the plains, Lake Magadi, and prime wildlife areas. Evoking the golden era of 1930s mobile safaris, each luxury tent features en-suite facilities, while dining under the stars brings an authentic, immersive Serengeti experience. Perfect for witnessing the Big Five and the Great Migration in unparalleled style." },
      { name: "Nyikani Central Serengeti", desc: "Nestled in the heart of the Central Serengeti, Nyikani Camp offers year-round access to Tanzania's iconic wildlife. Set amid endless rolling plains, it provides unrivaled views of wildebeest, zebra, and gazelle herds, making it the ultimate base for immersive safari adventures and Big Five encounters." },
      { name: "Lahia Tented Lodge", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775810942/Lahia_Tented_Camp_rgvqxi.webp", desc: "Perched on an elevated site in the Serengeti, Lahia Tented Lodge combines luxury and authenticity with elegantly furnished suites featuring locally sourced materials and traditional African art. Spacious bedrooms and refined design create a serene retreat after a day of unforgettable wildlife adventures." },
      { name: "Serengeti Mara River Camp", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775811494/Serengeti_Mara_River_Camp_ja2nb8.jpg", desc: "Situated along the Mara River, this exclusive tented camp offers unparalleled access to the dramatic river crossings of the Great Migration. With elegant, private tents and immersive safari experiences, guests can witness the Serengeti's iconic wildlife in comfort and style." },
    ],
  },
  {
    region: "Ngorongoro",
    lodges: [
      { name: "The Retreat at Ngorongoro", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775810939/Retreat_at_Ngorongoro_v134zu.webp", desc: "A nature-inspired sanctuary set on 60 acres overlooking the Ngorongoro Forest, this lodge combines luxury with tranquility. Surrounded by 40,000 indigenous trees and lush landscapes, guests can reconnect with nature while enjoying serene, elegant accommodations." },
      { name: "Ngorongoro Oldeani Mountain Lodge (Serena)", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775810961/Ngorongoro_Oldeani_Mountain_Lodge_Serena_l75jaz.jpg", desc: "A 5-star colonial lodge perched on a hilltop, offering panoramic views of Oldeani Mountain, the Ngorongoro Crater Rim, Lake Eyasi, and Lake Manyara. Set on 40 acres of lush gardens and native vegetation, it provides elegant accommodations amid spectacular scenery and abundant birdlife." },
      { name: "Ngorongoro Farm House", desc: "A small, exclusive lodge set on a 500-acre coffee plantation, blending colonial-style interiors with timeless comfort. Guests can stroll the fragrant gardens, enjoy spectacular sunsets over Oldeani Volcano, and use the lodge as a serene base for crater visits, walking safaris, or excursions to Lake Eyasi." },
    ],
  },
];

const kenyaLodges = [
  {
    region: "Mara",
    lodges: [
      { name: "Angama Mara", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812241/Angama_Mara_mkyhz0.avif", desc: "Perched 1,000 ft above the Mara plains on the Oloololo Escarpment, Angama Mara offers breathtaking, uninterrupted views across the savannah. Its name, meaning \"suspended in mid-air\" in Swahili, perfectly captures the lodge's airy elegance and unrivaled vantage points for wildlife and Great Migration experiences." },
      { name: "Mara Bushtops Camp", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812243/Mara_Bushtops_Camp_c64fyy.jpg", desc: "An award-winning luxury tented camp located in a private conservancy bordering the Masai Mara. Spacious tents with private decks, hot tubs, and sweeping savannah views offer an exclusive safari experience with exceptional wildlife viewing and personalized service." },
      { name: "Mara Serena Safari Lodge", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812250/Mara_Serena_Safari_Lodge_ve1ntf.jpg", desc: "Perched high on a bush-covered hill in the renowned Mara Triangle, Mara Serena Safari Lodge offers sweeping views of the savannah and the winding Mara River. Inspired by the circular design of a traditional Maasai manyatta, the lodge blends authentic African charm with modern comfort, providing an exceptional base for unforgettable Masai Mara safari adventures." },
      { name: "Mara Plains Camp", desc: "Nestled along the Ntiakitiak River on the edge of the Masai Mara, Mara Plains Camp offers an intimate luxury safari experience within the private Olare Motorogi Conservancy. With just seven elegant canvas suites overlooking the savannah, the camp provides exceptional big cat viewing, exclusive wildlife access, and a refined retreat for travelers seeking one of Kenya's most prestigious safari stays." },
      { name: "Mahali Mzuri", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812253/Mahali_Mzuri_glrdw2.jpg", desc: "Located in a private conservancy within the Masai Mara ecosystem, Mahali Mzuri offers an exclusive luxury safari experience with exceptional wildlife viewing. Guests can enjoy thrilling game drives, immersive Maasai cultural encounters, and relaxing spa treatments, all set against the breathtaking landscapes of the African savannah." },
    ],
  },
  {
    region: "Amboseli",
    lodges: [
      { name: "Tortilis Camp", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812293/Tortilis_Camp_rt2ymc.jpg", desc: "Set in a private conservancy bordering Amboseli National Park, Tortilis Camp offers breathtaking views of Mount Kilimanjaro framed by iconic Acacia Tortilis trees. This eco-friendly luxury camp features spacious tents, elegant communal spaces, and exclusive safari experiences including game drives, guided walks, and unforgettable bush dining." },
    ],
  },
  {
    region: "Laikipia / Ol Pejeta",
    lodges: [
      { name: "Sweetwaters Serena Camp", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812255/Sweetwaters_Serena_Camp_wgoldo.jpg", desc: "Located within the renowned Ol Pejeta Conservancy, Sweetwaters Serena Camp offers a classic tented safari experience surrounded by one of Kenya's richest wildlife areas. Home to the Big Five and sweeping views of Mount Kenya, the camp combines elegant comfort with exceptional game viewing in a stunning natural setting." },
    ],
  },
  {
    region: "Tsavo",
    lodges: [
      { name: "Salt Lick Safari Lodge", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812274/Saltlick_Safari_Lodge_iim34a.jpg", desc: "One of Kenya's most iconic safari lodges, Salt Lick Safari Lodge is uniquely built on stilts overlooking a busy wildlife waterhole in the Taita Hills Wildlife Sanctuary near Tsavo. Guests enjoy unforgettable up-close wildlife sightings from elevated rooms and viewing decks, making it a truly distinctive safari experience." },
    ],
  },
  {
    region: "Samburu",
    lodges: [
      { name: "Elephant Bedroom", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812250/Elephant_Bedroom_qztqnx.webp", desc: "Luxurious tents set along the Ewaso Ng'iro River, frequented by elephants at dusk" },
      { name: "Saruni Samburu", desc: "A stunning property with panoramic views of the Kalama Conservancy and mountain peaks" },
      { name: "Ol Malo Lodge", desc: "A family-owned ranch perched on the edge of the Laikipia Plateau with endless views" },
    ],
  },
];

const iconicExperiences = [
  { name: "Giraffe Manor – Nairobi", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812242/Giraffe_Manor1_sbgd9w.jpg", desc: "One of Kenya's most iconic boutique hotels, Giraffe Manor offers a truly unique stay where resident Rothschild's giraffes wander freely through the grounds and often visit guests during breakfast. Set within lush gardens and indigenous forest in Nairobi's Langata suburb, this elegant 1930s manor combines extraordinary wildlife encounters with timeless charm and exceptional hospitality." },
];

const beachResorts = [
  { name: "Swahili Beach Resort – Diani Beach", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812308/swahili_Beach_Resort_asrluw.png", desc: "Set along the pristine white sands of Diani Beach, Swahili Beach Resort is a stunning five-star retreat inspired by the rich heritage of the Swahili coast. Blending African, Arabian, and Indian design influences, the resort offers elegant accommodations, oceanfront tranquility, and an authentic cultural experience on one of Kenya's most beautiful beaches." },
  { name: "Medina Palms – Watamu", image: "https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto/f_auto/v1775812261/Medina_Palms_watamu_hggedp.webp", desc: "A stylish Swahili-inspired beach retreat in Watamu, Medina Palms offers elegant suites, penthouses, and beachfront villas surrounded by lush tropical gardens and serene pools. Blending contemporary luxury with traditional coastal architecture, it provides a sophisticated escape along one of Kenya's most beautiful shores." },
];

const countries = [
  { id: "all", label: "All Stays" },
  { id: "tanzania", label: "Tanzania" },
  { id: "kenya", label: "Kenya" },
  { id: "iconic", label: "Iconic & Beach" },
];

const HandpickedStays = () => {
  const [activeCountry, setActiveCountry] = useState("all");
  const [expandedRegion, setExpandedRegion] = useState(null);

  const toggleRegion = (region) => {
    setExpandedRegion(expandedRegion === region ? null : region);
  };

  const showTanzania = activeCountry === "all" || activeCountry === "tanzania";
  const showKenya = activeCountry === "all" || activeCountry === "kenya";
  const showIconic = activeCountry === "all" || activeCountry === "iconic";

  return (
    <div className="stays-page">
      {/* ===== HERO ===== */}
      <section className="stays-hero">
        <div className="stays-hero-bg-wrap">
          <img
            src="https://res.cloudinary.com/dn39bkkiq/image/upload/q_auto,f_auto,w_1920/v1776344742/Design_your_trip_hy5poj.jpg"
            alt="Luxury Safari Lodge"
            className="stays-hero-bg"
          />
        </div>
        <div className="stays-hero-overlay" />
        <div className="stays-hero-content">
          <span className="dest-hero-eyebrow">Handpicked For You</span>
          <h1 className="stays-hero-title">Top Stays You Will Love</h1>
          <p className="stays-hero-sub">
            From intimate tented camps on the Serengeti to elegant lodges overlooking the Masai Mara — every stay is chosen for comfort, location, and authenticity.
          </p>
          <div className="hero-buttons">
            <Link to="/tours" className="hero-cta primary">
              Browse Safari Packages <FaArrowRight className="btn-icon" />
            </Link>
            <Link to="/destinations" className="hero-cta secondary">
              Explore Destinations
            </Link>
          </div>
        </div>
      </section>

      {/* ===== FILTER TABS ===== */}
      <section className="stays-main">
        <div className="stays-main-inner">
          <span className="section-tag centered">Curated Collection</span>
          <h2 className="section-heading stays-section-heading">Where You'll Stay</h2>
          <p className="stays-intro">
            We personally vet every property. These are the lodges, camps, and resorts that consistently deliver extraordinary experiences.
          </p>

          <div className="stays-tabs">
            {countries.map((c) => (
              <button
                key={c.id}
                className={`stays-tab ${activeCountry === c.id ? "active" : ""}`}
                onClick={() => { setActiveCountry(c.id); setExpandedRegion(null); }}
              >
                {c.label}
              </button>
            ))}
          </div>

          {/* ===== TANZANIA ===== */}
          {showTanzania && (
            <div className="stays-country-block">
              <div className="stays-country-header">
                <FaMountain className="stays-country-icon tz" />
                <div>
                  <h3>Tanzania Safari Lodges</h3>
                  <p>{tanzaniaLodges.reduce((a, r) => a + r.lodges.length, 0)} handpicked stays across {tanzaniaLodges.length} regions</p>
                </div>
              </div>

              <div className="stays-regions">
                {tanzaniaLodges.map((region) => (
                  <div className="stays-region" key={region.region}>
                    <button
                      className={`stays-region-toggle ${expandedRegion === region.region ? "open" : ""}`}
                      onClick={() => toggleRegion(region.region)}
                    >
                      <FaMapMarkerAlt className="stays-region-pin" />
                      <span className="stays-region-name">{region.region}</span>
                      <span className="stays-region-count">{region.lodges.length} {region.lodges.length === 1 ? "lodge" : "lodges"}</span>
                      <FaChevronDown className="stays-region-chevron" />
                    </button>

                    {expandedRegion === region.region && (
                      <div className="stays-lodge-list">
                        {region.lodges.map((lodge, i) => (
                          <div className="stays-lodge-card" key={i}>
                            {lodge.image && <img src={lodge.image} alt={lodge.name} className="stays-lodge-card-img" />}
                            <div className="stays-lodge-card-row">
                              <div className="stays-lodge-card-accent tz" />
                              <div className="stays-lodge-card-body">
                                <div className="stays-lodge-card-top">
                                  <FaHotel className="stays-lodge-icon" />
                                  <h4>{lodge.name}</h4>
                                </div>
                                <p>{lodge.desc}</p>
                                <div className="stays-lodge-stars">
                                  {[...Array(5)].map((_, j) => <FaStar key={j} />)}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ===== KENYA ===== */}
          {showKenya && (
            <div className="stays-country-block">
              <div className="stays-country-header">
                <FaMountain className="stays-country-icon ke" />
                <div>
                  <h3>Kenya Safari Lodges</h3>
                  <p>{kenyaLodges.reduce((a, r) => a + r.lodges.length, 0)} handpicked stays across {kenyaLodges.length} regions</p>
                </div>
              </div>

              <div className="stays-regions">
                {kenyaLodges.map((region) => (
                  <div className="stays-region" key={region.region}>
                    <button
                      className={`stays-region-toggle ${expandedRegion === region.region ? "open" : ""}`}
                      onClick={() => toggleRegion(region.region)}
                    >
                      <FaMapMarkerAlt className="stays-region-pin" />
                      <span className="stays-region-name">{region.region}</span>
                      <span className="stays-region-count">{region.lodges.length} {region.lodges.length === 1 ? "lodge" : "lodges"}</span>
                      <FaChevronDown className="stays-region-chevron" />
                    </button>

                    {expandedRegion === region.region && (
                      <div className="stays-lodge-list">
                        {region.lodges.map((lodge, i) => (
                          <div className="stays-lodge-card" key={i}>
                            {lodge.image && <img src={lodge.image} alt={lodge.name} className="stays-lodge-card-img" />}
                            <div className="stays-lodge-card-row">
                              <div className="stays-lodge-card-accent ke" />
                              <div className="stays-lodge-card-body">
                                <div className="stays-lodge-card-top">
                                  <FaHotel className="stays-lodge-icon" />
                                  <h4>{lodge.name}</h4>
                                </div>
                                <p>{lodge.desc}</p>
                                <div className="stays-lodge-stars">
                                  {[...Array(5)].map((_, j) => <FaStar key={j} />)}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ===== ICONIC + BEACH ===== */}
          {showIconic && (
            <>
              <div className="stays-country-block">
                <div className="stays-country-header">
                  <FaGem className="stays-country-icon iconic" />
                  <div>
                    <h3>Iconic Experiences</h3>
                    <p>Bucket-list stays that define East Africa</p>
                  </div>
                </div>
                <div className="stays-lodge-list flat">
                  {iconicExperiences.map((lodge, i) => (
                    <div className="stays-lodge-card iconic" key={i}>
                      {lodge.image && <img src={lodge.image} alt={lodge.name} className="stays-lodge-card-img" />}
                      <div className="stays-lodge-card-row">
                        <div className="stays-lodge-card-accent iconic" />
                        <div className="stays-lodge-card-body">
                          <div className="stays-lodge-card-top">
                            <FaGem className="stays-lodge-icon" />
                            <h4>{lodge.name}</h4>
                          </div>
                          <p>{lodge.desc}</p>
                          <div className="stays-lodge-stars">
                            {[...Array(5)].map((_, j) => <FaStar key={j} />)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="stays-country-block">
                <div className="stays-country-header">
                  <FaUmbrellaBeach className="stays-country-icon beach" />
                  <div>
                    <h3>Kenya Beach Resorts</h3>
                    <p>The perfect post-safari wind-down</p>
                  </div>
                </div>
                <div className="stays-lodge-list flat">
                  {beachResorts.map((lodge, i) => (
                    <div className="stays-lodge-card beach" key={i}>
                      {lodge.image && <img src={lodge.image} alt={lodge.name} className="stays-lodge-card-img" />}
                      <div className="stays-lodge-card-row">
                        <div className="stays-lodge-card-accent beach" />
                        <div className="stays-lodge-card-body">
                          <div className="stays-lodge-card-top">
                            <FaUmbrellaBeach className="stays-lodge-icon" />
                            <h4>{lodge.name}</h4>
                          </div>
                          <p>{lodge.desc}</p>
                          <div className="stays-lodge-stars">
                            {[...Array(5)].map((_, j) => <FaStar key={j} />)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="cta-section cta-clean">
        <div className="cta-content">
          <span className="cta-eyebrow">Your Perfect Stay Awaits</span>
          <h2>Can't Decide? Let Us Help</h2>
          <p>
            Tell us your style — luxury, boutique, tented camp, or beachfront — and we'll match you with the perfect stays for your safari.
          </p>
          <div className="hero-buttons" style={{ justifyContent: "center" }}>
            <Link to="/tours" className="cta-button">
              Design My Safari <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HandpickedStays;
